import React from 'react';

function DetailedResults() {
    const openExternalPage = (e) => {
        try {
            const newWindow = window.open(e.currentTarget.value, "_blank", `width=800,height=850,top=20,left=${window.width - 100}`);
            if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                // alert('Pop-up blocker detected! Please allow pop-ups for this site to view the results.');
            }
        } catch (error) {
            console.error("Error opening window:", error);
            // alert('An error occurred while opening the link.');
        }
    };

    return (
        <div id="detailed-results" className="card cardBorder">
            <div className="map">
                <button onClick={openExternalPage} value="https://www.mathrubhumi.com/result/mapview/delhi.html" aria-label="Delhi Election Map">
                    <img src="https://www.mathrubhumi.com/result/delhi-election-2025/assets/delhi_2025_5.png" alt="Delhi Election Map" width="181" height="181"  />
                </button>
            </div>
            <div className="res-menus">
                <button className='res-menu' onClick={openExternalPage} value="https://www.mathrubhumi.com/result/delhi-election-2025/constituency-wise" aria-label="Constituency-wise Results">Constituency-wise</button>
                <button className='res-menu' onClick={openExternalPage} value="https://www.mathrubhumi.com/result/voteshare/delhi.html" aria-label="Vote Share">Vote Share</button>
                <button className='res-menu' onClick={openExternalPage} value="https://www.mathrubhumi.com/result/mapview/delhi.html" aria-label="Map View">Map View</button>
                <a className='res-menu' href="https://www.mathrubhumi.com/election/assembly-elections-2025/delhi-assembly-election/delhi-assembly-election-2025-results-aap-bjp-congress-1.10324119" target="_blank" aria-label="Live Blog" rel="noreferrer">Live Blog</a> {/* Changed to _blank for consistency */}
            </div>
        </div>
    );
}

export default DetailedResults;
